<template>
  <div class="imgBox">
   <input type="file" id="choose" @change="change" accept="image/*" :multiple="multiple">
  </div>
</template>
<script type="text/javascript">
import util from '../utils/util.js'
import { spaceUpPcHttp } from '../utils/api.js'
import Exif from 'exif-js'
var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
//    瓦片canvas
var tCanvas = document.createElement('canvas');
var tctx = tCanvas.getContext('2d');
export default {
  name: 'uploadImgSpaceup',
  props: {
    multiple:{
      type:Boolean,
      default:false
    },
    targetId:{//初始id
      type:Number,
      default:0
    },
    fileList:{
      type:Array,
      default:()=>[]
    },
    moduleCode:{
      type:String,
      default:''
    },
    index:{
      type:Number,
      default:0
    }
  },
  data () {
    return {
      maxsize: 1000 * 1024,
      url: spaceUpPcHttp+'/syscfg/attachmentTerminal/uploadFile',
      hex_md5_return:'',
      headers: {
        "Access-channel": "saas_rst",
      }
    };
  },
  created () {},
  methods: {
    resetSign(){
      // 公钥+私钥+时间戳+平台
      let gong = 'vanke2019spaceup009'
      let si = '009vanke2019spaceup001'
      this.timemap = new Date().getTime()
      let platfrom = 'SaasMobile'
      let str = gong+si+this.timemap+platfrom
      this.hex_md5_return = this.$md5(str)
    },
    change(val) {
      let that = this;
      let Orientation = '';
      let mess = val.target.files;
      var files = Array.prototype.slice.call(mess);
      if (files.length+this.fileList.length > 9) {
        util.showToast('最多只可上传9张图片')
        return false;
      }
      util.showLoading('上传中...')
      files.forEach(function (file, i) {
        if (!/\/(?:jpeg|png|gif)/i.test(file.type)) return;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function(){
          Orientation = Exif.getTag(this, 'Orientation');
        });
        var reader = new FileReader();
        reader.onload = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;
          // 如果图片大小小于1000kb，则直接上传
          if (result.length <= that.maxsize) {
            img = null;
            that.upload(result, file.type,file.name);
            return;
          }
          //图片加载完毕之后进行压缩，然后上传
          if (img.complete) {
            callback();
          } else {
            img.onload = callback;
          }
          function callback () {
            var data = that.compress(img,Orientation);
            that.upload(data, file.type,file.name);
            img = null;
          }
        };
        reader.readAsDataURL(file);
      })
    },
    // 图片上传，将base64的图片转成二进制对象，塞进formdata上传
    upload (basestr, type,name) {
      this.resetSign()
      let self = this;
      util.showLoading('上传中...')
      var text = window.atob(basestr.split(',')[1]);
      var buffer = new Uint8Array(text.length);
      for (var i = 0; i < text.length; i++) {
        buffer[i] = text.charCodeAt(i);
      }
      var blob = this.getBlob([buffer], type);
      var formdata = new FormData();
      formdata.append('files', blob,'1.jpg');// 传文件
      formdata.append('target', self.targetId);
      formdata.append('moduleCode', this.moduleCode);
      formdata.append('platform', "SaasMobile");
      formdata.append('timestamp',self.timemap);
      formdata.append('sign',self.hex_md5_return);
      formdata.append('companyId',self.$store.state.common.marketInfo.cityId);//self.$store.state.marketInfo.cityId
      fetch(self.url, {
        method: 'post',
        body: formdata,
        headers:self.headers
      }).then(response => response.json()).then(res => {
        console.log(res)
        if (res.code == 1000) {
          util.hideLoading()
          this.$emit('uploadImgEnd',{data:res.data[0],index:this.index})
        } else {
          util.hideLoading()
        }
      })
    },
    getBlob (buffer, format) {
      try {
        return new Blob(buffer, {type: format});
      } catch (e) {
        var bb = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MSBlobBuilder)();
        buffer.forEach(function (buf) {
          bb.append(buf);
        });
        return bb.getBlob(format);
      }
    },
    compress (img,Orientation) {
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;
      // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio;
      if ((ratio = width * height / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      // 铺底色
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 如果图片像素大于100万则使用瓦片绘制
      var count;
      if ((count = width * height / 1000000) > 1) {
        count = ~~(Math.sqrt(count) + 1); // 计算要分成多少块瓦片
        // 计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if(Orientation != "" && Orientation != 1){
        switch(Orientation){
          case 6://需要顺时针（向左）90度旋转
            this.rotateImg(img,'left',canvas);
            break;
          case 8://需要逆时针（向右）90度旋转
            this.rotateImg(img,'right',canvas);
            break;
          case 3://需要180度旋转
            this.rotateImg(img,'right',canvas);//转两次
            this.rotateImg(img,'right',canvas);
            break;
        }
      }
      // 进行最小压缩
      var ndata = canvas.toDataURL('image/jpeg', 0.6);
      console.log('压缩前：' + initSize);
      console.log('压缩后：' + ndata.length);
      console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + '%');
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg (img, direction,canvas) {
        //最小与最大旋转方向，图片旋转4次后回到原方向
        const min_step = 0;
        const max_step = 3;
        if (img == null)return;
        //img的高度和宽度不能在img元素隐藏后获取，否则会出错
        let height = img.height;
        let width = img.width;
        let step = 2;
        if (step == null) {
          step = min_step;
        }
        if (direction == 'right') {
          step++;
          //旋转到原位置，即超过最大值
          step > max_step && (step = min_step);
        } else {
          step--;
          step < min_step && (step = max_step);
        }
        //旋转角度以弧度值为参数
        let degree = step * 90 * Math.PI / 180;
        let ctx = canvas.getContext('2d');
        switch (step) {
          case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            break;
          case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height);
            break;
          case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height);
            break;
          case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0);
            break;
        }
    }
  }
};
</script>
<style lang="less" scoped>
.imgBox{
  width:100%;
  height:100%;
  input{
    width:100%;
    height:100%;
    display: block;
  }
}
</style>
